module.exports = __webpack_public_path__ + "static/media/yhjt.a2fbce1e.png";